export const SITES_STORAGE_KEY = 'vivosol-sites';

function storage() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }
  return window.localStorage;
}

export function readStoredSites(sub) {
  const localStorage = storage();
  if (!localStorage) return [];

  try {
    const parsed = JSON.parse(localStorage.getItem(SITES_STORAGE_KEY) || 'null');
    if (!parsed || !Array.isArray(parsed.sites)) return [];
    if (sub && parsed.sub && parsed.sub !== sub) return [];
    return parsed.sites;
  } catch {
    return [];
  }
}

export function writeStoredSites(sub, sites) {
  const localStorage = storage();
  if (!localStorage) return;

  localStorage.setItem(SITES_STORAGE_KEY, JSON.stringify({
    sub: sub || null,
    sites: Array.isArray(sites) ? sites : [],
  }));
}

export function clearStoredSites() {
  storage()?.removeItem(SITES_STORAGE_KEY);
}
